import React, { useEffect, useState } from "react";
import Filter from "./Filter";
import ProductsListing from "./ProductsListing";

const ProductFilterWrapper = ({ products, filteredProducts, handleClick }) => {
  const [brands, setBrands] = useState([]);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState({});
  let colorsData = [];
  let sizesData = {};
  let brandsData = [];
  useEffect(() => {
    products.map((product) => {
      product?.options?.map((option) => {
        if (option?.name === "Color" || option?.name === "Colour") {
          option?.values.map((color) => {
            if (!colorsData.includes(color)) {
              colorsData.push(color);
            }
          });
        }
        if (option?.name === "Size") {
          option?.values.map((size) => {
            sizesData[size] = sizesData[size] ? sizesData[size] + 1 : 1;
          });
        }
      });
      if (!brandsData.includes(product?.vendor)) {
        brandsData.push(product.vendor);
      }
    });
    setColors(colorsData);
    setSizes(sizesData);
    setBrands(brandsData);
  }, []);

  return (
    <div className="relative flex flex-wrap mb-5 ml-[5px] max-w-full w-full box-border">
      <Filter colors={colors} sizes={sizes} brands={brands} />
      <ProductsListing products={filteredProducts} handleClick={handleClick} />
    </div>
  );
};

export default ProductFilterWrapper;
